import { useEffect, useState } from 'react';

export const usePageScrolled = (offset?: number) => {
  const threshold = offset ? offset : 0;
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = (): void => {
    if (window.scrollY > threshold) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return isScrolled;
};
